import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import queryString from 'query-string';

import { ENV } from '@shared/config';
import { TSearchResponse } from '@shared/types';

import { NotesListQueryKey } from './keys';

interface SearchParams {
  q: string;
}

export function useSearchMutation() {
  return useMutation<TSearchResponse, unknown, SearchParams, unknown>(
    [NotesListQueryKey],
    async ({ q }: SearchParams) => {
      const requestLink = `${ENV.API}/search/?q=${q}&${queryString.stringify({
        page: 1,
        pagelen: 5,
        lang: ENV.LANG,
      })}`;

      const resp = await axios.get<unknown, { data: TSearchResponse }>(requestLink, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      return resp.data;
    },
  );
}
